import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminArticleEdit from "@/pages/admin/AdminArticleEdit";

export const Route = createFileRoute("/admin/articles/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminArticleEdit />
    </ProtectedRoute>
  ),
});
